module.exports = __webpack_public_path__ + "img/mobile-phone.75004dd7.svg";